module.exports = __webpack_public_path__ + "static/img/NO SEW_deskstop.d86d8d28.jpg";